var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 17,
    viewBox: "0 0 22 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "artwork"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 22,
    height: 16,
    rx: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector",
    d: "M19.9048 0.5H2.09524C0.93807 0.5 0 1.45513 0 2.63333V14.3667C0 15.5449 0.93807 16.5 2.09524 16.5H19.9048C21.0619 16.5 22 15.5449 22 14.3667V2.63333C22 1.45513 21.0619 0.5 19.9048 0.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0.5H9V8.5H0V0.5Z",
    fill: "#1A47B8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.49124 6.07529L2.95124 6.89982L3.24457 5.15475L2 3.91742L3.72124 3.66355L4.49124 2.07422L5.26124 3.66355L6.98248 3.91955L5.73581 5.15475L6.03124 6.89982",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 8.5H22V16.5H0V8.5Z",
    fill: "#F93939"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4315_2281"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 22,
    height: 16,
    rx: 2,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChile);
export default __webpack_public_path__ + "static/media/chile.986c2c5ec98ff55e9a64cef096a23814.svg";
export { ForwardRef as ReactComponent };